import styled, { css, keyframes } from 'styled-components'

import { color, radius, spacing, typography } from '../../../themes'

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`

interface ContainerProps {
  open?: boolean
  position?: 'center'
}

export const Container = styled.div<ContainerProps>`
  animation: ${({ open }) => (open ? fadeIn : fadeOut)} 0.3s ease;
  background: ${color('gradient.primary')};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${radius('md')};
  width: 90%;
  max-width: 400px;
  z-index: 150;
  position: absolute;

  ${({ position = 'center' }) =>
    position === 'center' &&
    css`
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    `}
`

export const Inner = styled.div`
  background: ${color('white')};
  margin: 1px;
  width: 100%;
  border-radius: 7px;
  padding: ${spacing(6)} ${spacing(2)} ${spacing(2)};
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  min-height: 180px;
`

export const Title = styled.header`
  ${typography('headline3')};
  color: ${color('gray.01')};
  padding: 0 ${spacing(4)};
`

export const Body = styled.div`
  ${typography('body2')};
  color: ${color('gray.02')};
  width: 100%;
  margin-top: ${spacing(5)};
  padding-left: ${spacing(4)};
  padding-right: ${spacing(4)};
`
